import React from "react";
import {Label, Radio, TextInput} from "flowbite-react";
import {SingleChoiceSelect_SurveyQuestionPage_Options, SingleSelectValue} from "data/models/survey/single-choice";
import {RenderableTitle} from "data/models/survey/base";
import {CHOICE_ITEM_CLASS, QUESTION_CONTAINER_CLASS, TEXT_INPUT_THEME} from "components/Survey/classes";
import {sortChoiceValues} from "helpers/sort-choice-values";
import {OptionalTooltip} from "components/OptionalTooltip";

export type ChoiceSelect_SurveyQuestionPage_Props = {
  options: SingleChoiceSelect_SurveyQuestionPage_Options,
  title: RenderableTitle,
  description: RenderableTitle | null,
  questionId: string,
  value: SingleSelectValue | undefined,
  onChange: (id: string, value: SingleSelectValue) => void,
}

const OTHER_CHOICE_KEY = "reserved:other";

export default function SingleChoiceSelectSurveyQuestionPage(
    {
      options,
      title,
      description,
      questionId,
      value,
      onChange
    }: ChoiceSelect_SurveyQuestionPage_Props
) {

  return <div className={"flex flex-col w-full"}>
    <div className={QUESTION_CONTAINER_CLASS}>
      <div className={"my-4 text-center"}>{title}</div>
      {description !== null && <div className={"my-4 text-center"}>{description}</div>}
      <fieldset name={questionId} className={"flex gap-4 mt-8 justify-center flex-col"} autoFocus={true}>
        {(options.sorted ? sortChoiceValues(options.choices) : options.choices)
            .map((choice, index) => <div key={index} className="flex flex-col items-center gap-2">
              <OptionalTooltip
                  showTooltip={choice.tooltip !== undefined}
                  content={<>{choice.tooltip ?? ""}</>}
              >
                <Radio
                    className="hidden peer"
                    id={`${questionId}.${choice.key}`}
                    value={choice.key}
                    checked={value?.value === choice.key}
                    onChange={({target: {value: changedValue}}) => onChange(questionId, {
                      value: changedValue,
                    })}
                />
                <Label htmlFor={`${questionId}.${choice.key}`}
                       className={CHOICE_ITEM_CLASS}>
                  {choice.value}
                </Label>
              </OptionalTooltip>
            </div>)}
        {options.otherInputBox && <div className={"mt-8 text-center"}>
            <Radio
                className="peer"
                id={`${questionId}.${OTHER_CHOICE_KEY}`}
                value={OTHER_CHOICE_KEY}
                checked={value?.other !== undefined}
                onChange={() => onChange(questionId, {
                  other: value?.other ?? ""
                })}
            />
            <Label htmlFor={`${questionId}.${OTHER_CHOICE_KEY}`}
                   className={"inline-flex py-1 px-10 cursor-pointer"}>
                <span className={"mr-4 my-auto text-lg font-normal text-neutral-500"}>Other</span>
                <TextInput
                    className={"min-w-80"}
                    id={questionId}
                    theme={TEXT_INPUT_THEME}
                    sizing={"lg"}
                    type={"text"}
                    value={value?.other ?? ""}
                    disabled={value?.other === undefined}
                    onChange={({target: {value: editValue}}) => onChange(questionId, {
                      other: editValue
                    })}
                />
            </Label>
        </div>}
      </fieldset>
    </div>
  </div>
}
